<ion-header class="ion-no-border">
    <ion-toolbar>
        <ion-button (click)='close()' fill='clear' slot='start'>Close</ion-button>
        <ion-title>Select Business Account</ion-title>
    </ion-toolbar>
</ion-header>
<ion-content>

    <div sxCol sxGap='10px' sxPadding="medium">

        <div *ngFor='let org of userOrganisations$ | async' sxPadding='medium' sxRadius='medium' sxBackground='light'
             (click)='onOrgSelect(org)'>
            {{org.name}}
        </div>

    </div>

</ion-content>
